import * as signalR from '@microsoft/signalr'
import { computed, onUnmounted, watchEffect } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import useUserStore from '@/store/user'
import { EventBus } from '@/utils/EventBus'

export default function useAtendenteTicketsSignalRNotifications() {
  const { id, isLoggedIn } = storeToRefs(useUserStore())

  const url = computed(() => ({
    remote: `${process.env.VUE_APP_FLOW.replace('api/', '')}atendente-tickets-hub?AtendenteId=${id.value}`,
    local: `https://localhost:7294/atendente-tickets-hub?AtendenteId=${id.value}`,
  }))

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(url.value.remote, { transport: signalR.HttpTransportType.WebSockets })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.None)
    .build()

  async function startConnection() {
    try {
      connection.baseUrl = url.value.remote
      await connection.start()
    } catch {
      setTimeout(startConnection, 5000)
    }
  }

  async function stopConnection() {
    if (connection.state === signalR.HubConnectionState.Disconnected) return
    await connection.stop()
  }

  async function resetConnection() {
    await stopConnection()
    await startConnection()
  }

  watchEffect(async () => {
    if (isLoggedIn.value) {
      await resetConnection()
    } else {
      await stopConnection()
    }
  })

  onUnmounted(stopConnection)

  async function showPushNotification(message) {
    let granted = false

    if (Notification.permission === 'granted') {
      granted = true
    } else {
      const permission = await Notification.requestPermission()
      granted = permission === 'granted'
    }

    if (granted) {
      const notification = new Notification(message.title, {
        body: message.body,
        icon: 'https://vikdocumentdb.blob.core.windows.net/utils/logo-vik.png?sv=2021-10-04&st=2023-08-15T01%3A33%3A30Z&se=2033-08-16T01%3A33%3A00Z&sr=b&sp=r&sig=ZryzjVz5WrPBS7AnGx6uB95KsAQk3BgvGJZdYOWLxBY%3D',
        tag: 'ticket',
        lang: 'pt-BR',
        vibrate: true,
      })

      setTimeout(() => { notification.close() }, 30 * 1000)
    }
  }

  connection.on('ReceiveTicket', message => {
    showPushNotification(JSON.parse(message))
    EventBus.$emit('fetch-tickets')
    EventBus.$emit('reset-slas-contadores')
  })

  connection.on('ReceiveTicketMessage', message => {
    showPushNotification(JSON.parse(message))
    EventBus.$emit('fetch-ticket-messages')
    EventBus.$emit('fetch-ticket-anexos')
    EventBus.$emit('reset-slas-contadores')
  })
}
